var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_6115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 42C9.24 42 6.07386 41.4055 3.33415 38.6659C0.581538 35.9068 0 32.76 0 21C0 9.24 0.594462 6.09324 3.33415 3.33415C6.07386 0.594462 9.24 0 21 0C32.76 0 35.9261 0.594462 38.6659 3.33415C41.4185 6.09324 42 9.24 42 21C42 32.76 41.4185 35.9068 38.6659 38.6659C35.9261 41.4055 32.76 42 21 42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2389 20.9808C28.4377 20.9808 27.9143 20.4509 27.9143 19.6691C27.9143 18.9001 28.4441 18.3768 29.2389 18.3768H31.3324V20.9808H29.2389ZM33.0835 16.8648H29.0321C27.3134 16.8648 26.1374 17.9891 26.1374 19.6044C26.1374 20.8838 26.8675 21.8531 28.0241 22.1891L25.8143 25.5555H27.7721L29.7623 22.4928H31.326V25.5555H33.0835V16.8648ZM11.166 19.1457V16.5223H14.5712V23.9595H10.3001C10.7589 23.1583 11.166 21.3038 11.166 19.1457ZM16.374 14.8423H9.42785V19.2168C9.42785 21.446 9.03366 23.1841 8.51028 23.966H7.67676V27.9334H9.39552V25.5878H15.8959V27.9334H17.6146V23.966H16.374V14.8423ZM21.6143 24.0823L21.4592 23.9789L23.4881 16.8648H19.385L18.9457 18.4478L21.33 18.4284L19.7792 23.8561C19.5078 24.8448 20.1734 25.7623 21.2589 25.7623C21.6014 25.7623 21.9374 25.6783 22.3121 25.4392L25.1035 23.5524L24.2506 22.2924L21.6143 24.0823ZM22.8032 15.23C23.669 15.23 24.0309 14.9069 24.0309 14.138C24.0309 13.3368 23.6561 13.0137 22.8032 13.0137C21.9503 13.0137 21.5755 13.3368 21.5755 14.138C21.582 14.9069 21.9374 15.23 22.8032 15.23Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_6115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiia);
export default __webpack_public_path__ + "static/media/diia.70667a252889e7403100953951cf8df0.svg";
export { ForwardRef as ReactComponent };